import React, { useEffect } from "react";
import { Form, Row, Col, InputNumber, Divider, ColorPicker } from "antd";
import { get } from "lodash";
import { calcualteShiftMinutes, calculateProductionTime } from "../../../../utilities/totalProductionCount";

const InjectionMouldingMetaForm = ({
  prefix,
  disbaleMandaotryField,
  initialValues,
  form,
  part,
}) => {
  const updatePlannedProduction = () => {
    if (form) {
      const cavityVal = form.getFieldValue([prefix, "cavity"]);
      const downTimeValue = form.getFieldValue([prefix, "planned_down_time"]);
      const cycleTimeVal = form.getFieldValue([prefix, "cycle_time"]);

      form.setFieldsValue({
        [prefix]: {
          planned_production: calculateProductionTime(
            get(initialValues, "start", 0),
            get(initialValues, "end", 0),
            get(part, "meta.cycle_time", 0) || cycleTimeVal,
            cavityVal||0,
            downTimeValue||0
          ),
        },
      });
    }
  };

  useEffect(() => {
    if (part) {
      const partCavity = get(part, "meta.cavity");
      const partCycleTime = get(part, "meta.cycle_time");
      const partWeight = get(part, "meta.part_weight", 0);
      const partShotWeight = get(part, "meta.shot_weight", 0);
      const initialPlannedDownTime = get(
        initialValues,
        "config.meta.planned_down_time"
      );

      form.setFieldsValue({
        [prefix]: {
          cavity: partCavity,
          cycle_time: partCycleTime,
          part_weight: partWeight,
          shot_weight: partShotWeight,
          planned_down_time: initialPlannedDownTime,
        },
      });
      setTimeout(() => {
        updatePlannedProduction();
      }, 0);
    }
  }, [part, initialValues, form, prefix]);
  return (
    <>
      <Divider orientation="left">Injection Mouldings</Divider>
      <Row gutter={25}>
        <Col md={12} xs={24}>
          <Form.Item
            label="Cavity"
            name={[prefix, "cavity"]}
            rules={[
              {
                required: true,
                message: "Please input Cavity number...!",
              },
              {
                type: "number",
                min: 1,
                message: `Cavity should be greater than 1`,
              },
              {
                type: "number",
                max: 50,
                message: `Cavity should be less than or equal to 50`,
              },
            ]}
          >
            <InputNumber
              defaultValue={0}
              min={1}
              max={50}
              onChange={() => {
                updatePlannedProduction();
              }}
              precision={0}
              style={{ width: "100%" }}
              placeholder="Cavity"
            />
          </Form.Item>
        </Col>
        <Col md={12} xs={24}>
          <Form.Item
            label="Rejected count"
            name={[prefix, "rejected_count"]}
            rules={[
              {
                required: true,
                message: "Please input Rejected count number...!",
              },
            ]}
          >
            <InputNumber
              defaultValue={0}
              precision={0}
              style={{ width: "100%" }}
              placeholder="Rejected count"
            />
          </Form.Item>
        </Col>
        <Col md={12} xs={24}>
          <Form.Item
            label="Planned down time"
            name={[prefix, "planned_down_time"]}
            dependencies={["start", "end"]}
            rules={[
              {
                required: true,
                message: "Please input Planned down time...!",
              },
              {
                type: "number",
                min: 0,
                validator: (_, value) => {
                  const startTime = form.getFieldValue("start");
                  const endTime = form.getFieldValue("end");
                  const maxAllowedMinutes = calcualteShiftMinutes(
                    startTime,
                    endTime
                  );
                  if (value === undefined || value === null || isNaN(value)) {
                    return Promise.resolve();
                  }

                  if (value > maxAllowedMinutes - 10) {
                    return Promise.reject(
                      new Error(
                        `Planned down time should be less than ${
                          maxAllowedMinutes - 10
                        } minutes`
                      )
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <InputNumber
              addonAfter="minutes"
              defaultValue={0}
              onChange={() => {
                updatePlannedProduction();
              }}
              precision={0}
              style={{ width: "100%" }}
              min={0}
            placeholder="Planned down time"

            />
          </Form.Item>
        </Col>
        <Col md={12} xs={24}>
          <Form.Item
            label="Cycle time"
            defaultValue={0}
            name={[prefix, "cycle_time"]}
            rules={[
              {
                required: true,
                message: "Please input Cycle time...!",
              },
            ]}
          >
            <InputNumber
              addonAfter="seconds"
              disabled={disbaleMandaotryField}
              precision={0}
              defaultValue={0}
            placeholder="Cycle time"
              onChange={() => {
                updatePlannedProduction();
              }}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col md={12} xs={24}>
          <Form.Item
            label="Planned production count"
            name={[prefix, "planned_production"]}
            rules={[
              {
                required: true,
                message: "Please input Planned production count number...!",
              },
            ]}
          >
            <InputNumber
              precision={0}
              style={{ width: "100%" }}
              defaultValue={0}
              min={0}
              placeholder="Planned production count"
            />
          </Form.Item>
        </Col>
        <Col md={12} xs={24}>
          <Form.Item
            label="Wages per hour"
            name={[prefix, "wages_per_hour"]}
            rules={[
              {
                required: true,
                message: "Please input Wages per hour...!",
              },
            ]}
          >
            <InputNumber
              addonBefore="₹"
              addonAfter=""
              precision={undefined}
              defaultValue={0}
              style={{ width: "100%" }}
              placeholder="Wages per hour"
            />
          </Form.Item>
        </Col>
        <Col md={12} xs={24}>
          <Form.Item label="Shot Weight" name={[prefix, "shot_weight"]}>
            <InputNumber
              addonAfter="gm"
              defaultValue={0}
              precision={2}
              style={{ width: "100%" }}
              placeholder="Shot Weight"
            />
          </Form.Item>
        </Col>
        <Col md={12} xs={24}>
            <Form.Item
              label="Part Weight"
              name={[prefix, "part_weight"]}
              dependencies={[[prefix, "shot_weight"]]}
              rules={[
                {
                  type: "number",
                  min: 0,
                  validator: (_, partWeightValue) => {
                    const shotWeightValue = form.getFieldValue([
                      prefix,
                      "shot_weight",
                    ]);
                    if (
                      shotWeightValue === undefined ||
                      shotWeightValue === null ||
                      isNaN(shotWeightValue)
                    ) {
                      return Promise.resolve();
                    }
                    if (
                      partWeightValue === undefined ||
                      partWeightValue === null ||
                      isNaN(partWeightValue)
                    ) {
                      return Promise.resolve();
                    }

                    if (partWeightValue > shotWeightValue) {
                      return Promise.reject(
                        new Error("Part Weight cannot exceed Shot weight.")
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <InputNumber
                addonAfter="gm"
                placeholder="Part Weight"
                defaultValue={0}
                precision={2}
                style={{ width: "100%" }}
                min={0}
              />
            </Form.Item>
        </Col>
        <Col md={12} xs={24}>
          <Form.Item label="color" name={[prefix, "color"]}>
            <ColorPicker
              showText
              onChange={(value) =>
                form.setFieldValue([prefix, "color"], value.toHexString())
              }
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default InjectionMouldingMetaForm;
